<template>
  <div class="studentManage">
    <div class="cardInline">
      <Row class="item border-line">
        <Col span="12" class="card lf">注册量</Col>
        <Col span="12" class="card rt">
<!--          <Icon style="color:#f60;" type="ios-information-circle"></Icon>-->
<!--          12个月未成单的学员，将自动解除绑定关系-->
        </Col>
      </Row>
      <Row class="item">
        <Col span="8" class="card card2">
          <Tag color="green">今日</Tag>
          <b>{{cardInline.todayRegisterCount}}</b>
          人

        </Col>
        <Col span="8" class="card card2">
          <Tag color="blue">本月</Tag>
          <b>{{cardInline.monthRegisterCount}}</b>
          人

        </Col>
        <Col span="8" class="card">
          <Tag color="orange">累计注册</Tag>
          <b>{{cardInline.registerCount}}</b>
          人

        </Col>
      </Row>
    </div>
    <div class="filter">
      <div class="box">
        <span class="title">状态：</span>
        <RadioGroup v-model="radioVal" @on-change="radioChange">
          <Radio label="-1" border>全部</Radio>
          <Radio label="0" border>未下单</Radio>
          <Radio label="1" border>未支付</Radio>
          <Radio label="3" border>已购课</Radio>
        </RadioGroup>
      </div>
      <div class="box">
        <span class="title">条件：</span>
        <Input v-model="input" placeholder="用户名" style="width: 200px"/>
        <DatePicker class="time" @on-change="times" v-model="time" type="daterange" placement="bottom-end"
                    placeholder="请选择开始时间，结束时间" :editable='false' style="width: 220px"></DatePicker>
        <Button type="primary" @click="search">查询</Button>
        <Button class="reset" @click="reset">重置</Button>
      </div>
    </div>
    <div class="tbl">
      <Table :loading="loading" border :columns="columns" :data="tblData"></Table>
      <Page @on-change="pageChange" @on-page-size-change="pageSizeChange" :total="total" :page-size="params.pgSize"
            :current="params.pgIndex" show-total show-elevator show-sizer></Page>
    </div>

    <Modal v-model="previewModal" title="学生详情" width="1100" footer-hide>
      <info ref="info" v-if="previewModal" :uid="uid" :info="info"/>
    </Modal>
  </div>
</template>

<script>
  import info from "./info";

  export default {
    name: "studentManage",
    components: {
      info
    },
    data() {
      return {
        previewModal: false,
        uid: '',
        info: {},
        registerType: ['手机', '第三方'],
        registerFrom: ['其他', 'PC端', 'wap端', 'App_Ios端', 'App_Android端', 'QQ', '微信', '微博', '微信小程序', '百度小程序', '头条小程序', '支付宝小程序', '手机快捷'],
        orderType: [
          {
            value: '未下单',
            color: '#fb9b91'
          },
          {
            value: '未支付',
            color: '#bebebe'
          },
          {
            value: '',
            color: ''
          },
          {
            value: '已购课',
            color: '#1890ff'
          }
        ],
        loading: true,
        cardInline: {},
        input: '',
        time: ['', ''],
        radioVal: '-1',
        params: {
          unionID: '',
          seacherContext: '',
          type: -1,
          startTime: '',
          endTime: '',
          pgIndex: 1,
          pgSize: 10,
        },
        total: 0,
        tblData: [],
        columns: [
          {
            title: "用户名",
            key: "userName",
          },
          // {
          //   title: "手机号码",
          //   key: "mobilePhone",
          // },
          // {
          //   title: "姓名",
          //   key: "trueName",
          // },
          {
            title: "注册方式",
            key: "registerType",
            render: (h, params) => {
              return h("span", {
                style: {}
              }, this.registerType[params.row.registerType]);
            }
          },
          {
            title: "注册来源",
            key: "registerFrom",
            render: (h, params) => {
              return h("span", {
                style: {}
              }, this.registerFrom[params.row.registerFrom]);
            }
          },
          {
            title: "注册时间",
            key: "registerTime",
            width: 200
          },
          {
            title: "状态",
            key: "orderType",
            render: (h, params) => {
              return h("span", {
                style: {
                  color: this.orderType[params.row.orderType].color,
                }
              }, this.orderType[params.row.orderType].value);
            }
          },
          {
            title: "操作",
            key: "action",
            width: 150,
            render: (h, params) => {
              return h("span", {
                style: {
                  color: '#e13b29',
                  cursor: 'pointer'
                },
                on: {
                  click: () => {
                    this.getStudentInfo(params.row.uid);
                    this.info = params.row;
                  }
                }
              }, "查看详情")
            }
          }
        ]
      }
    },
    methods: {
      radioChange(e) {
        this.params.type = e;
        this.getList();
      },
      getStudentInfo(uid) {
        this.uid = uid;
        this.previewModal = true;
      },
      times(e) {
        console.log(e);
        this.time = e;
      },
      reset() {
        this.loading = true;
        this.input = '';
        this.time = ['', ''];
        this.radioVal = '-1';
        this.params = {
          unionID: '',
          seacherContext: '',
          type: -1,
          startTime: '',
          endTime: '',
          pgIndex: 1,
          pgSize: 10,
        };
        this.total = 0;
        this.tblData = [];
        this.getList();
      },
      search() {
        this.params = {
          unionID: '',
          seacherContext: this.input,
          type: this.radioVal,
          startTime: this.time[0],
          endTime: this.time[1],
          pgIndex: 1,
          pgSize: 10,
        };
        console.log(this.params);
        this.getList();
      },
      getStatic() {
        this.$store.dispatch('effect/studentStatic').then(res => {
          this.cardInline = res;
        })
      },
      getList() {
        this.$store.dispatch('effect/studentList', this.params).then(res => {
          if (res.s === 10006) {
            this.loading = false;
            this.tblData = res.list;
            this.total = res.count;
          } else {
            this.loading = false;
            this.tblData = [];
            this.total = 0;
          }
        });
      },
      pageChange(val) {
        this.params.pgIndex = val;
        this.getList();
      },
      pageSizeChange(val) {
        this.params.pgSize = val;
        this.getList();
      },
      getInfo() {
        this.getStatic();
        this.getList();
      },
    },
    created() {
      this.getInfo();
    }
  }
</script>
<style scoped lang="scss">
  .studentManage {
    .cardInline {
      margin-bottom: 20px;
      border: 1px solid #E8EAEC;

      .item {
        line-height: 40px;

        .card {
          padding: 0 16px;

          .ivu-tag {
            float: left;
            margin-top: 9px;
            margin-right: 8px;
          }
        }

        .card2 {
          border-right: 1px solid #E8EAEC;
        }

        .rt {
          text-align: right;
        }
      }

      .border-line {
        border-bottom: 1px solid #E8EAEC;
      }
    }

    .filter {
      text-align: left;
      margin-bottom: 20px;

      .box {
        margin-bottom: 10px;

        .title {
          min-width: 80px;
          display: inline-block;
          vertical-align: -4px;
        }

        .buttonList {
          width: calc(100% - 80px);
          vertical-align: top;

          .ivu-btn {
            margin-bottom: 10px;
          }
        }

        .time {
          margin: 0 10px;
        }

        .reset {
          margin-left: 10px;
        }
      }
    }

    .tbl {
      .ivu-page {
        text-align: right;
        margin: 20px 0;
      }
    }
  }
</style>